import { Injectable } from '@angular/core';
import { Api } from './api.service';
import { RequestConfiguration } from '../models/request-configuration';
import { ContactEmailCommand } from '../services/service-proxies';
import { FreightPostConfiguration } from '../models/freight-post-configuration';

@Injectable()
export class CommonApi extends Api {
    private controllerName = 'api/common';

    getEquipmentTypes() {
        return this.get(`${this.controllerName}/get-equipment-types`);
    }

    getUserSetting() {
        return this.get<{dateTimeFormat: string, language: string, timeZone: string}>('api/common/get-user-setting');
    }

    getCountries() {
        return this.get(`${this.controllerName}/get-countries`);
    }

    getTimezone() {
        return this.get(`${this.controllerName}/get-timezone`);
    }

    getUserNotifications() {
        return this.get<Notification[]>(`${this.controllerName}/get-user-notifications`);
    }

    countUnreadUserNotification() {
        return this.get<number>(`${this.controllerName}/count-unread-user-notification`);
    }

    updateAllNotificaionAsRead() {
        return this.get(`${this.controllerName}/update-all-notification-as-read`);
    }

    getCurrencies() {
        return this.get(`${this.controllerName}/get-currencies`);
    }

    getRequestConfiguration() {
        return this.get<RequestConfiguration>(`${this.controllerName}/get-request-configuration`);
    }

    getFreightPostConfiguration() {
        return this.get<FreightPostConfiguration>(`${this.controllerName}/get-freight-post-configuration`);
    }

    getCompanyLogo(userId: any){
        return this.get(`${this.controllerName}/get-company-logo/${userId}`);
    }

    getCurrentUser(){
        return this.get(`${this.controllerName}/get-current-user`);
    }
    getBusinessUnitByOrganizationId(organizationId: any) {
        return this.get(`${this.controllerName}/get-business-unit/${organizationId}`);
    }

    updateLanguage(lang: string) {
        return this.get(`${this.controllerName}/update-language/${lang}`);
    }

    sendContactEmail(command: ContactEmailCommand) {
        return this.post(`${this.controllerName}/send-contact-email`, command);
    }

    getAppConfiguration() {
        return this.get(`${this.controllerName}/get-app-configuration`);
    }
}
